interface PagesNames {
    [key: string]: string;
}

export const pageNames: PagesNames = {
    homePage: 'home',
    reportPage: 'reportDetail',
    referencePage: 'referenceDetail'
};
